<template>
    <transition name="fade">
        <div id="changement-commission-modal" class="modal modal-default">
            <div class="modal__overlay" @click="$emit('close')"></div>
            <div class="small-modal">
                <div class="small-modal__close" @click="$emit('close')">X</div>
                <div class="small-modal__head">
                    <span>Changement de commission</span>
                </div>
                <div class="small-modal__body" v-if="isBusy">
                    <Preloader />
                </div>
                <div class="small-modal__body" v-else>
                    <div class="small-modal__body__block">
                        <div class="small-modal__body__block--title text-capitalize text-center mb-0">
                            <span class="commission-amount-label">COMMISSION:</span>
                            <span class="commission-amount-box">
                                <span class="commission-amount">{{slider.value}}</span>&nbsp;€ 
                            </span>
                        </div>
                        <div class="small-modal__body__block__content commission-amount-range">
                            <div class="small-modal__body__block__content--input">
                                <div class="commission-slider">
                                    <div class="commission-slider__min"><span>{{slider.min}}</span> €</div>
                                    <input class="commission-slider__input" type="range" v-model="slider.value" :min="slider.min" :max="slider.max" :step="slider.step" @input="calcMonthlyPrice" />
                                    <div class="commission-slider__max"><span>{{slider.max}}</span> €</div>
                                </div>
                            </div>
                            <div class="small-modal__body__block__content--error" style="font-size:14px;color:red;" v-if="error">
                                {{error}}
                            </div>
                        </div>
                        <div class="small-modal__body__block--title text-capitalize text-center mb-0">
                            <span class="commission-amount-label">PRIME MENSUELLE:</span>
                            <span class="commission-amount-box">
                                <span class="commission-amount">{{monthly_price}}</span>&nbsp;€ 
                            </span>
                        </div>
                    </div>
                </div>
                <div class="small-modal__footer">
                    <div class="small-modal__footer__actions d-flex justify-content-between">
                        <button class="blue-button" @click.prevent="$emit('close')">
                            <span>Annuler</span>
                        </button>
                        <button class="green-button" @click.prevent="submit" :disabled="sending||isBusy">
                            <span v-if="sending">
                                <svg
                                    width="24" height="24" viewBox="0 0 50 50"
                                    xmlns="http://www.w3.org/2000/svg" aria-label="Loading" role="img">
                                    <circle
                                        cx="25" cy="25" r="20"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="6"
                                        stroke-linecap="round"
                                        stroke-dasharray="90 150"
                                        transform="rotate(-90 25 25)">
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            from="0 25 25"
                                            to="360 25 25"
                                            dur="1s"
                                            repeatCount="indefinite" />
                                    </circle>
                                </svg>
                            </span>
                            <span v-else>Valider</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>    
</template>

<script>
import Preloader from '@/components/Preloader'

export default {
    name: 'ChangementCommissionModal',
    components: {
      Preloader
    },
    props: {
        quote: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isBusy: true,
            sending: false,
            slider: {
                min: 0,
                max: 80,
                step: 10,
                value: 0
            },
            monthly_price: 0,
            error: null,
            duration_to_months: {
                3: 12,
                4: 24,
                5: 36,
                6: 48
            },
            tax: 18
        }
    },
    methods: {
        fetch() {
            this.apiGet(`garantie/${this.quote.id}/monthly/get-commission`)
                .then(response => {
                    if (response.data && response.data.status === 'success' && response.data.commission) {
                        this.slider = response.data.commission;
                        this.slider.value = parseInt(this.slider.value);
                        this.calcMonthlyPrice();
                    }
                    this.isBusy = false;
                })
                .catch(error => {
                    this.showErrorNotification(error);
                    this.isBusy = false;
                });
        },
        submit() {
            this.sending = true;
            this.apiPost(`garantie/${this.quote.id}/monthly/set-custom-commission`, {commission: this.slider.value})
                .then(response => {
                    if(response.data && response.data.status === 'success') {
                        this.showSuccessNotification("La commission a été modifiée avec succès.");
                        this.$emit('close');
                        this.$emit('refresh-quote');
                    } else {
                        this.showErrorNotification("Une erreur est survenue.");
                    }
                    this.sending = false;
                })
                .catch(error => {
                    this.showErrorNotification(error);
                    this.sending = false;
                });
        },
        reset() {
            this.isBusy = true;
            this.sending = false;
            this.slider.value = 0;
            this.error = null;
            this.monthly_price = 0;
            this.fetch();
        },
        calcMonthlyPrice() {
            let monthlyCommission = parseInt(this.slider.value) / this.duration_to_months[this.quote.details.duration];
            let tax = monthlyCommission * this.tax / 100;
            this.monthly_price = parseFloat(parseFloat(this.quote.monthly_price_without_commission) + monthlyCommission + tax).toFixed(2);
        }
    }
};
</script>

<style scoped>
#changement-commission-modal .commission-amount-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
#changement-commission-modal .commission-amount-range {
    margin: 10px 0 20px 0;
}
#changement-commission-modal .commission-amount {
    font-size: 32px;
    font-weight: bold;
}
#changement-commission-modal .commission-slider {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
}
#changement-commission-modal .commission-slider__min, #changement-commission-modal .commission-slider__max {
    color: #666;
    font-size: 16px;
}
#changement-commission-modal .commission-slider__input {
    flex: 1;
    margin: 0 10px;
    padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Commissions/ChangementCommissionModal.vue